import {FunctionComponent} from 'react';

import { ReactComponent as ContactImage } from '../../../../assets/images/illustratie_contact.svg';
import University from '../../../../networking/models/University';
import Response from '../../../../networking/models/Response';

interface Props {
    university: University;
    responses: Response[];
}

const ContactContent: FunctionComponent<Props> = (props) => {

    return (
        <>
            <div className={'contact-page__image-container'}>
                <ContactImage className={'contact-page__image'} />
            </div>

            <div className={'contact-page__content'}>
                <div className={'contact-page__header'}>
                    <h1 className={'contact-page__main-title'}>Contact</h1>

                    <span className={'contact-page__subtitle'}>{ props.university.name }</span>
                </div>

                { props.responses.map(response => (
                    <div className={'contact-page__text-group'} key={response.id}>
                        <div className={'contact-page__group'}>
                            <span className={'contact-page__title'}>{ response.first_name } { response.last_name }</span>

                            <div className={'contact-page__email-text'}>
                                <span className={'contact-page__text contact-page__text--grey'}>{ response.email_private }</span>
                                <span className={'contact-page__text contact-page__text--grey'}>{ response.email_han }</span>
                            </div>

                            <span className={'contact-page__text contact-page__text--bold'}>{ response.han_study_programme }</span>
                        </div>

                        <div className={'contact-page__group'}>
                            <span className={'contact-page__text'}>{ response.comment }</span>
                        </div>
                    </div>
                )) }
            </div>
        </>
    );
};

export default ContactContent;
